<template>
  <div>
    <SOSlotModalVue
      modal-title="Pilih Waktu Training"
      :modal-id="'popUpJadwal'"
      :no-padding="true"
      @close="close"
    >
      <template v-slot:modal-body>
        <template v-for="(jadwal, index) in dataTimeExist">
          <button
            class="btn remove-padding-margin w-100"
            :disabled="jadwal.available == true ? false : true"
            @click="
              changeDate(
                date_format.toPost,
                jadwal.jam_mulai,
                jadwal.jam_selesai
              )
            "
            :key="index"
          >
            <p class="f-16 f-Overpass f-c-black p-t-16 p-x-20 d-flex">
              {{ date_format.toDisplay }}
              {{ formatJam(jadwal.jam_mulai) }} -
              {{ formatJam(jadwal.jam_selesai) }}
            </p>
          </button>
        </template>
      </template>
    </SOSlotModalVue>
  </div>
</template>

<script>
import SOSlotModalVue from "@/so-components/global/slot/SOSlotModal.vue";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";
export default {
  name: "ModalScedule",
  components: {
    SOSlotModalVue,
  },

  props: {
    paramsIdjenis: "",
    tanggal_jadwal: "",
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters(moduleName, {
      dataTimeExist: "dataTimeExist",
      dataRescedule: "dataRescedule",
      date_format: "date_format",
    }),
  },

  methods: {
    changeDate(tanggal_jadwal, jam_mulai, jam_selesai) {
      this.dataRescedule.jadwal_mulai =
        this.$moment(tanggal_jadwal).format("YYYY-MM-DD") + " " + jam_mulai;
      this.dataRescedule.jadwal_selesai =
        this.$moment(tanggal_jadwal).format("YYYY-MM-DD") + " " + jam_selesai;

      $(`#popUpJadwal`).modal("hide");
    },
    formatJam(jam) {
      return jam.slice(0, -3);
    },
    open() {
      $(`#popUpJadwal`).modal("show");
    },
    close() {
      this.resetDateState();
      $(`#popUpJadwal`).modal("hide");
    },

    resetDateState() {
      (this.date_format.toPost = ""), (this.date_format.toDisplay = "");
    },
    async init() {},
  },
};
</script>
